var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AfyButton, AfyModal } from "@affinitysystemsgroup/assurehub-ui";
import { MODAL_DELETE_CANCEL_LABEL, MODAL_DELETE_CONFIRM_LABEL, MODAL_DELETE_TITLE, modalDeleteQuestion, } from "../../../constants/productCreation.constants";
import { ModalDeleteButtons, ModalDeleteDescription, } from "../style/modalConfirmationDelete.style";
var MODAL_PROPS = {
    centered: true,
    size: "md",
};
var BUTTON_PROPS = {
    variant: "filled",
    size: "md",
};
export var ModalConfirmationDelete = function (props) { return (_jsxs(AfyModal, __assign({}, MODAL_PROPS, { opened: props.openModal, onClose: function () { return props.setOpenModal(false); }, title: "".concat(MODAL_DELETE_TITLE, " ").concat(props.titleDelete) }, { children: [_jsx(ModalDeleteDescription, { children: modalDeleteQuestion(props.subTitleDelete) }), _jsxs(ModalDeleteButtons, { children: [_jsx(AfyButton, __assign({}, BUTTON_PROPS, { label: MODAL_DELETE_CANCEL_LABEL, color: "brand", onClick: function () { return props.setOpenModal(false); } })), _jsx(AfyButton, __assign({}, BUTTON_PROPS, { label: MODAL_DELETE_CONFIRM_LABEL, color: "red", onClick: props.onConfirmDelete }))] })] }))); };
